import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12 1.875A5.125 5.125 0 0 1 17.125 7v2.375h.25a2.25 2.25 0 0 1 2.25 2.25v8.25a2.25 2.25 0 0 1-2.25 2.25H6.625a2.25 2.25 0 0 1-2.25-2.25v-8.25a2.25 2.25 0 0 1 2.25-2.25h.25V7a5.125 5.125 0 0 1 4.908-5.12zm5.375 9H6.625a.75.75 0 0 0-.75.75v8.25c0 .414.336.75.75.75h10.75a.75.75 0 0 0 .75-.75v-8.25a.75.75 0 0 0-.75-.75zM12 13.75a.75.75 0 0 1 .75.75V17a.75.75 0 1 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75zm0-10.375A3.625 3.625 0 0 0 8.375 7v2.375h7.25V7c0-1.937-1.52-3.52-3.432-3.62z' />
  </svg>
);
